import { ArrowSquareOutIcon, Mtds } from 'prove-common'

type LinkExternalProps = {
  to: string
  text: string
}

export const LinkExternal = ({ to, text, ...props }: LinkExternalProps) => {
  return (
    <Mtds.Link
      href={to}
      target='_blank'
      className='inline-flex items-center gap-1 text-text-default'
      {...props}
    >
      <strong>{text}</strong> <ArrowSquareOutIcon />
    </Mtds.Link>
  )
}
